export default {
  // Default variant
  //-------------------------------------------------------------------------
  default: {
    container: "relative w-full",
    containerVertical: "flex flex-row h-full",
    tabList: "flex flex-row border-b border-neutral_1 relative",
    tabListVertical: "flex flex-col border-r border-neutral_1 border-b-0",
    tab: "relative px-4 py-2 text-sm font-medium transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 flex items-center gap-2",
    tabActive: "text-primary border-b-2 border-primary",
    tabInactive:
      "text-text_secondary hover:text-text border-b-2 border-transparent",
    tabEnabled: "cursor-pointer",
    tabDisabled: "cursor-not-allowed opacity-50",
    tabSmall: "px-3 py-1.5 text-xs",
    tabLarge: "px-6 py-3 text-base",
    tabIcon: "w-4 h-4",
    tabLabel: "",
    tabBadge:
      "ml-2 px-2 py-0.5 text-xs bg-primary/10 text-primary rounded-full",
  },

  // Compact variant
  //-------------------------------------------------------------------------
  compact: {
    container: "relative w-full",
    containerVertical: "flex flex-row h-full",
    tabList: "flex flex-row border-b border-neutral_1 relative",
    tabListVertical: "flex flex-col border-r border-neutral_1 border-b-0",
    tab: "relative px-3 py-1.5 text-xs font-medium transition-all duration-200 focus:outline-none focus-visible:ring-1 focus-visible:ring-primary/20 flex items-center gap-1.5",
    tabActive: "text-primary border-b-2 border-primary",
    tabInactive:
      "text-text_secondary hover:text-text border-b-2 border-transparent",
    tabEnabled: "cursor-pointer",
    tabDisabled: "cursor-not-allowed opacity-50",
    tabSmall: "px-2 py-1 text-xs",
    tabLarge: "px-4 py-2 text-sm",
    tabIcon: "w-3.5 h-3.5",
    tabLabel: "",
    tabBadge:
      "ml-1.5 px-1.5 py-0.5 text-xs bg-primary/10 text-primary rounded-full",
  },

  // Large variant
  //-------------------------------------------------------------------------
  large: {
    container: "relative w-full",
    containerVertical: "flex flex-row h-full",
    tabList: "flex flex-row border-b border-neutral_1 relative",
    tabListVertical: "flex flex-col border-r border-neutral_1 border-b-0",
    tab: "relative px-6 py-3 text-base font-medium transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 flex items-center gap-3",
    tabActive: "text-primary border-b-2 border-primary",
    tabInactive:
      "text-text_secondary hover:text-text border-b-2 border-transparent",
    tabEnabled: "cursor-pointer",
    tabDisabled: "cursor-not-allowed opacity-50",
    tabSmall: "px-4 py-2 text-sm",
    tabLarge: "px-8 py-4 text-lg",
    tabIcon: "w-5 h-5",
    tabLabel: "",
    tabBadge:
      "ml-3 px-2.5 py-1 text-sm bg-primary/10 text-primary rounded-full",
  },

  // Admin variant (for admin interface)
  //-------------------------------------------------------------------------
  admin: {
    container: "relative w-full",
    containerVertical: "flex flex-row h-full",
    tabList:
      "flex flex-row border-b border-admin_neutral_1 relative",
    tabListVertical:
      "flex flex-col border-r border-admin_neutral_1 border-b-0 bg-admin_paper",
    tab: "relative px-6 py-3 text-sm font-medium transition-all duration-200 focus:outline-none  flex items-center gap-2 rounded-t-lg",
    tabActive:
      "text-admin_primary bg-admin_paper border-b-2 border-admin_primary",
    tabInactive:
      "text-admin_text_secondary hover:text-admin_text hover:bg-admin_canvas/50 border-b-2 border-transparent",
    tabEnabled: "cursor-pointer",
    tabDisabled: "cursor-not-allowed opacity-50",
    tabSmall: "px-4 py-2 text-xs",
    tabLarge: "px-8 py-4 text-base",
    tabIcon: "w-4 h-4",
    tabLabel: "",
    tabBadge:
      "ml-2 px-2 py-0.5 text-xs bg-admin_primary/10 text-admin_primary rounded-full",
  },

  // Pills variant
  //-------------------------------------------------------------------------
  pills: {
    container: "relative w-full",
    containerVertical: "flex flex-row h-full",
    tabList: "flex flex-row gap-2 p-1 bg-neutral_1 rounded-lg",
    tabListVertical: "flex flex-col gap-2 p-1 bg-neutral_1 rounded-lg",
    tab: "relative px-4 py-2 text-sm font-medium transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 flex items-center gap-2 rounded-md",
    tabActive: "text-white bg-primary shadow-sm",
    tabInactive: "text-text_secondary hover:text-text hover:bg-white/50",
    tabEnabled: "cursor-pointer",
    tabDisabled: "cursor-not-allowed opacity-50",
    tabSmall: "px-3 py-1.5 text-xs",
    tabLarge: "px-6 py-3 text-base",
    tabIcon: "w-4 h-4",
    tabLabel: "",
    tabBadge: "ml-2 px-2 py-0.5 text-xs bg-white/20 text-current rounded-full",
  },

  // Admin pills variant
  //-------------------------------------------------------------------------
  admin_pills: {
    container: "relative w-full",
    containerVertical: "flex flex-row h-full",
    tabList: "flex flex-row gap-2 p-1 bg-admin_neutral_1 rounded-lg",
    tabListVertical: "flex flex-col gap-2 p-1 bg-admin_neutral_1 rounded-lg",
    tab: "relative px-4 py-2 text-sm font-medium transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-admin_primary/20 flex items-center gap-2 rounded-md",
    tabActive: "text-white bg-admin_primary shadow-sm",
    tabInactive:
      "text-admin_text_secondary hover:text-admin_text hover:bg-admin_paper/50",
    tabEnabled: "cursor-pointer",
    tabDisabled: "cursor-not-allowed opacity-50",
    tabSmall: "px-3 py-1.5 text-xs",
    tabLarge: "px-6 py-3 text-base",
    tabIcon: "w-4 h-4",
    tabLabel: "",
    tabBadge: "ml-2 px-2 py-0.5 text-xs bg-white/20 text-current rounded-full",
  },

  // Minimal variant
  //-------------------------------------------------------------------------
  minimal: {
    container: "relative w-full",
    containerVertical: "flex flex-row h-full",
    tabList: "flex flex-row gap-6 relative",
    tabListVertical: "flex flex-col gap-4 relative",
    tab: "relative px-0 py-2 text-sm font-medium transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 flex items-center gap-2",
    tabActive: "text-primary",
    tabInactive: "text-text_secondary hover:text-text",
    tabEnabled: "cursor-pointer",
    tabDisabled: "cursor-not-allowed opacity-50",
    tabSmall: "py-1.5 text-xs",
    tabLarge: "py-3 text-base",
    tabIcon: "w-4 h-4",
    tabLabel: "",
    tabBadge:
      "ml-2 px-2 py-0.5 text-xs bg-primary/10 text-primary rounded-full",
  },
}
